import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

//import Home from "./pages/Home";
import Tabela from "./pages/TabelaCaixa";
import UserHome from "./pages/UserHome";
import Login from "./pages/Login";
import CreateMov from "./pages/CreateMov";
import Page404 from "./pages/Page404";

export default function Routes () {
    return(

        <BrowserRouter>
            <Switch>
                <Route path = '/' component={UserHome} exact/>       
                <Route path = '/login' component={Login} />
                <Route path = '/fluxo-de-caixa' component={Tabela} />
                {/* <Route path = '/user-home' component={UserHome} /> */}
                <Route path = '/create-mov' component={CreateMov} />
                <Route component={Page404} />
            </Switch>
        </BrowserRouter>

    );
}